// Should match output from @doordash/lib-platform
export enum OsTypes {
  Android = 'Android',
  iOS = 'iOS',
  NONE = 'None',
}

export type DasherCredentials = {
  token: string
  dasherId: string
  uniqueLink: string
}

export enum IOSNames {
  IOS_DISABLE_NAVBAR_HEADER = 'disableHeader',
  IOS_ENABLE_NAVBAR_HEADER = 'enableHeader',
  /**
   * IOS_LOAD_URL: Opens URL in an in-app browser (as opposed to app-switch)
   */
  IOS_LOAD_URL = 'loadUrl',
  IOS_REQUEST_CREDENTIALS = 'requestCredentials',
}
